import "../../constants/amplify_config"; // Ensure Amplify config loads first

import { useEffect, useState } from "react";

import { get } from "aws-amplify/api";
import { useDispatch } from "react-redux";

import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

import { updateTokenExpiryStatus } from "../../redux/tokenSlice";
import CustomReactPlayer from "../ReactPlayer/ReactPlayer";

export default function LiveStreamComponent() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [liveStreamOptions, setLiveStreamOptions] = useState([]);

  const getLiveStreamData = async () => {
    try {
      setIsLoading(true);
      const idToken = sessionStorage.getItem("idToken");
      if (!idToken) {
        console.error("No idToken found in sessionStorage.");
        throw new Error("No idToken found");
      }
      // Use the API name from Amplify configuration ("api")
      const apiName = "api";
      const path = "event/all/?Status=In Progress";
      const init = {
        headers: {
          accept: "application/json",
          Token: `${idToken}`,
        },
      };

      // Retrieve response from API
      const response = await get({
        apiName: apiName,
        path: path,
        options: init,
      }).response;

      const data = await response.body.json();
      const streams = Array.isArray(data.Items) ? data.Items : [];

      // Filter out streams with Program equal to "hitchcock-backfill"
      const filteredStreams = streams.filter((stream) => {
        if (stream.Program.toLowerCase() === "hitchcock-backfill") {
          console.log("Filtering out stream:", stream);
          return false;
        }
        return true;
      });

      // Set the filtered streams in state
      setLiveStreamOptions(filteredStreams);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      dispatch(updateTokenExpiryStatus(true));
      console.error("Error making authenticated request:", error);
      throw error;
    }
  };

  useEffect(() => {
    getLiveStreamData();
  }, []);

  return (
    <Box
      className="live-stream-parent-container"
      sx={{
        flex: 3,
        background: theme.palette.primary.dark,
      }}
    >
      {/* <Topics /> */}
      <Box className="live-stream-container">
        <Typography variant="h5" fontWeight={700} margin={"1rem"}>
          Live Video Streams
        </Typography>
        <Box
          className="live-stream-list"
          sx={{
            placeContent: isLoading ? "center" : "",
            placeItems: isLoading ? "center" : "",
          }}
        >
          {isLoading && (
            <CircularProgress
              size={36}
              thickness={6}
              sx={{ color: "#AC1FFF" }}
            />
          )}
          {!isLoading && liveStreamOptions.length < 1 && (
            <Typography variant="body1">No live streams available</Typography>
          )}
          {!isLoading &&
            liveStreamOptions?.map((stream, index) => (
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                width="100%"
                height={
                  liveStreamOptions?.length === 3
                    ? "50%"
                    : liveStreamOptions?.length > 3
                      ? "90%"
                      : "70%"
                }
                key={index}
              >
                <CustomReactPlayer
                  // width={liveStreamOptions?.length > 2 ? "400px" : "900px"}
                  // height={liveStreamOptions?.length > 2 ? "200px" : "60vh"}
                  width={"100%"}
                  height={"100%"}
                  url={stream.SourceVideoUrl}
                  playing
                  controls
                  muted
                />
                <Typography variant="body1" marginTop={"0.5rem"}>
                  {stream?.Stream}
                  {/* Bloomberg Live TV */}
                </Typography>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
}
